module.exports = __webpack_public_path__ + "static/img/95555.a31caab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/95555.png
// module id = E/mW
// module chunks = 18